'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Props {
  companyName?: string;
}

function getCurrentTaxWeek(): string {
  const now = new Date();
  const taxYearStart = new Date(now.getFullYear(), 3, 6); // April 6
  if (now < taxYearStart) taxYearStart.setFullYear(taxYearStart.getFullYear() - 1);
  const diffMs = now.getTime() - taxYearStart.getTime();
  const week = Math.floor(diffMs / (7 * 24 * 60 * 60 * 1000)) + 1;
  return `TW${week}`;
}

export default function DashboardSubHeader({ companyName }: Props) {
  const [dateStr, setDateStr] = useState('');
  const [taxWeek, setTaxWeek] = useState('');

  useEffect(() => {
    const now = new Date();
    setDateStr(now.toLocaleDateString('en-GB', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' }));
    setTaxWeek(getCurrentTaxWeek());
  }, []);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-semibold text-card-foreground">Platform Dashboard</h1>
          {companyName && (
            <span className="text-xs px-2 py-0.5 rounded-full font-medium"
              style={{ background: 'rgba(0,212,255,0.1)', color: 'var(--primary)', border: '1px solid rgba(0,212,255,0.2)' }}>
              {companyName}
            </span>
          )}
        </div>
        <p className="text-sm text-muted-foreground mt-0.5">
          {dateStr} · Tax Year 2025/26
        </p>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm"
          style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
          <Icon name="CalendarDaysIcon" size={14} className="text-primary" />
          <span className="text-xs font-medium text-card-foreground">{taxWeek || '—'}</span>
        </div>

        <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium hover:bg-muted transition-colors"
          style={{ background: 'var(--card)', border: '1px solid var(--border)', color: 'var(--secondary-foreground)' }}>
          <Icon name="ArrowDownTrayIcon" size={13} />
          Export
        </button>
      </div>
    </div>
  );
}